export default "__VITE_ASSET__DnLIDInu__"